import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { IAIRepository } from '@/api/fe-api/domain/repositories/ai-respository';

export namespace GetPromptList {
  export const key = (): string[] => ['ai', 'get-prompt-list'];

  export type Output = IAIRepository.GetPromptListOutput;

  export function useQuery() {
    const { repositories } = useDependencies();

    return rq.useQuery({
      queryKey: key(),
      queryFn: () => repositories.ai.getPromptList(),
    });
  }
}
